export default __webpack_public_path__ + "static/media/notification.f1f96272.wav";